import { SIGNUP_URL } from '../config';

function CTA() {
  return (
    <section class="container text-center py-[clamp(4rem,8vh,7rem)]">
      <h2 class="font-display text-[clamp(1.75rem,4vw,2.75rem)] font-extrabold tracking-[-0.025em] mb-4">
        Unlimited AI, your way
      </h2>
      <p class="text-muted text-[1.05rem] mb-8 max-w-[480px] mx-auto">
        Chat, think, and build without limits — pay for GPU time, not tokens. Open
        source and free to self-host.
      </p>
      <div class="flex gap-4 justify-center flex-wrap">
        <a href={SIGNUP_URL} target="_blank" rel="noopener" class="btn-primary">
          <svg width="16" height="16" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" viewBox="0 0 24 24">
            <path d="M13 2L3 14h9l-1 8 10-12h-9l1-8z" />
          </svg>
          Sign Up
        </a>
        <a
          href="https://github.com/ThatCatDev/tanrenai"
          target="_blank"
          rel="noopener"
          class="btn-secondary"
        >
          <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
            <path d="M12 0C5.37 0 0 5.37 0 12c0 5.31 3.435 9.795 8.205 11.385.6.105.825-.255.825-.57 0-.285-.015-1.23-.015-2.235-3.015.555-3.795-.735-4.035-1.41-.135-.345-.72-1.41-1.23-1.695-.42-.225-1.02-.78-.015-.795.945-.015 1.62.87 1.845 1.23 1.08 1.815 2.805 1.305 3.495.99.105-.78.42-1.305.765-1.605-2.67-.3-5.46-1.335-5.46-5.925 0-1.305.465-2.385 1.23-3.225-.12-.3-.54-1.53.12-3.18 0 0 1.005-.315 3.3 1.23.96-.27 1.98-.405 3-.405s2.04.135 3 .405c2.295-1.56 3.3-1.23 3.3-1.23.66 1.65.24 2.88.12 3.18.765.84 1.23 1.905 1.23 3.225 0 4.605-2.805 5.625-5.475 5.925.435.375.81 1.095.81 2.22 0 1.605-.015 2.895-.015 3.3 0 .315.225.69.825.57A12.02 12.02 0 0 0 24 12c0-6.63-5.37-12-12-12z" />
          </svg>
          View on GitHub
        </a>
      </div>
    </section>
  );
}

export default CTA;
